import { useAuthContext } from '@/features/auth/context'
import useUser from '@/features/auth/hooks/useUser'
import { useEffect, type ReactElement } from 'react'
import toast from 'react-hot-toast'
import { Navigate, useLocation } from 'react-router-dom'
import LoadingScreen from '../common/LoadingScreen'
import { useAppDispatch } from '@store/stores'
import { setUser, fetchUserPermissions } from '@store/slices/user/userSlice'

interface RequireIsLoggedInProps {
  roles: string[]
  children: ReactElement
  redirectTo: string
}

const RequireIsLoggedIn = ({
                             roles,
                             redirectTo,
                             children,
                           }: RequireIsLoggedInProps) => {
  const { isLogin, interfaceId } = useAuthContext()
  const { pathname: from } = useLocation()
  const { data: user, isLoading } = useUser()
  const isIncludes = roles.includes(user?.role)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (isIncludes && !isIncludes) toast.error('Permission denied!')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIncludes, isLoading])

  useEffect(() => {
    if (user) {
      dispatch(setUser(user))
    }
  }, [user, dispatch])

  /**
   * @todo: maybe find better place to fetch permissions
   */
  useEffect(() => {
    if (user && interfaceId && !isLoading) {
      dispatch(fetchUserPermissions(Number(interfaceId)))
        .unwrap()
        .catch((error) => {
          console.error('Failed to fetch user permissions:', error)
        })
    }
  }, [user, interfaceId, isLoading, dispatch])

  if (!isLogin) return <Navigate replace to={'/'} />

  if (isLoading) {
    return <LoadingScreen />
  }

  if (isIncludes) {
    return children
  }

  return <Navigate replace to={redirectTo} state={{ from }} />
}

export default RequireIsLoggedIn
